const TRUTHY_DEBUG_VALUES = ['1', 'true', 'yes', 'on'];
const DEFAULT_DEBUG_ENV_KEY = 'RAZZLE_DEBUG_MODE';

export const isBrowser = () =>
  typeof window !== 'undefined' && typeof window.console !== 'undefined';

export const getClientEnvValue = (envKey) => {
  if (!isBrowser()) return '';

  const processEnvValue =
    typeof process !== 'undefined' && process?.env
      ? process.env?.[envKey]
      : undefined;

  return window?.env?.[envKey] || processEnvValue || '';
};

export const getClientDebugFlag = (envKey = DEFAULT_DEBUG_ENV_KEY) => {
  if (!isBrowser()) return false;

  const value = getClientEnvValue(envKey);
  return TRUTHY_DEBUG_VALUES.includes(String(value).toLowerCase());
};

const isLikelyDevelopmentHost = () => {
  if (!isBrowser()) return false;
  const host = window?.location?.hostname || '';
  return (
    host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local')
  );
};

export const isClientDebugEnabled = ({
  envKey = DEFAULT_DEBUG_ENV_KEY,
  enabledInDevelopment = true,
} = {}) => {
  const enabledByEnv = getClientDebugFlag(envKey);
  const nodeEnv =
    typeof process !== 'undefined' && process?.env
      ? process.env.NODE_ENV
      : undefined;
  const enabledByEnvironment =
    enabledInDevelopment &&
    (nodeEnv ? nodeEnv !== 'production' : isLikelyDevelopmentHost());

  return isBrowser() && (enabledByEnvironment || enabledByEnv);
};

const clientConsoleLog = (...args) => {
  if (!isBrowser()) return;
  // eslint-disable-next-line no-console
  window.console.log(...args);
};

// Simple usage: debugClient('message', details)
export const debugClient = (...args) => {
  if (!isClientDebugEnabled()) return;
  clientConsoleLog('[DEBUG]', ...args);
};

export const createClientLogger = ({
  prefix = '[DEBUG]',
  envKey = DEFAULT_DEBUG_ENV_KEY,
  enabledInDevelopment = true,
} = {}) => {
  return (...args) => {
    if (!isClientDebugEnabled({ envKey, enabledInDevelopment })) return;
    clientConsoleLog(prefix, ...args);
  };
};
